import React, { useState, useEffect } from 'react';
import './ExportDoc.scss';
// import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { Layout } from 'antd';
import { Switch, BrowserRouter as Router, useLocation } from 'react-router-dom';
import SideBarComponent from '../layouts/sideBar';
import { PrivateRoute, PublicRoute } from '../core/routeAuthentication';
import { authService } from '../core/auth';
import HeaderBar from '../layouts/headerBar';
import LoginComponent from '../pages/login';
import { routeConfig } from '../shared/common/constant';
import ConsigneeList from '../pages/businessPartners/consigneeList';
import Register from '../pages/register';
import Consignee from '../pages/businessPartners/consignee';
import AddEditBank from '../pages/businessPartners/addEditBank';
import ProductList from '../pages/masterDetails/productList';
import ProformaList from '../pages/addEditProforma/proformaList';
import AddEditProforma from '../pages/addEditProforma/addEditProforma';
import CreateCompany from '../pages/company/createCompany';
import DeliveryTerm from '../pages/masterDetails/deliveryTerm';
import PackingType from '../pages/masterDetails/packingType';
import PaymentTerm from '../pages/masterDetails/paymentTerm';
import ShippingMode from '../pages/masterDetails/shippingMode';
import AddCompanyBankDetails from '../pages/company/addCompanyBankDetails';
import PageNotFound from '../pages/pageNotFoundComponent';
import Dashboard from '../pages/dashboard';
import AddEditPreShipmentInvoice from '../pages/addEditPreShipmentInvoice/addEditPreShipmentInvoice';
import AddEditCommercialInvoice from '../pages/addEditCommercialInvoice/addEditCommercialInvoice';
import PreShipmentInvoicePdf from '../pages/addEditPreShipmentInvoice/PreShipmentInvoicePdf';
import CommercialInvoicePdf from '../pages/addEditCommercialInvoice/commercialInvoicePdf';
import CompanyAllBanksList from '../pages/company/companyAllBanksList';
import PreShipmentList from '../pages/addEditPreShipmentInvoice/preShipmentList';
import ProformaInvoicePdfViewer from '../pages/addEditProforma/ProformaInvoicePdfViewer';
import AddEditPackingListInvoice from '../pages/addEditPackingList/addEditPackingListInvoice';
import PackingList from '../pages/addEditPackingList/allPackingList';
import PackingListPdf from '../pages/addEditPackingList/PackingListPdf';
import AddEditPurchaseOrder from '../pages/addEditPurchaseOrder/addEditPurchaseOrder';
import PurchaseOrderList from '../pages/addEditPurchaseOrder/purchaseOrderList';
import CommercialInvoiceList from '../pages/addEditCommercialInvoice/commercialInvoiceList';
import PurchaseOrderPdf from '../pages/addEditPurchaseOrder/PurchaseOrderPdf';
import PortList from '../pages/masterDetails/portLists';
import CountryList from '../pages/masterDetails/countrylist';
import AddEditFinalPackingListInvoice from '../pages/addEditFinalPackingList/addEditFinalPackingListInvoice';
import FinalPackingListPdf from '../pages/addEditFinalPackingList/FinalPackingListPdf';
import FinalPackingList from '../pages/addEditFinalPackingList/allFinalPackingList';
import AccountSettings from '../pages/accountSettings';
import ConfrimEmailComponent from '../pages/confrimEmail';
import ForgotPasswordComponent from '../pages/forgotPassword';
import ResetPasswordComponent from '../pages/resetPassword';
import { RefreshToken } from '../shared/common/graphqlQuery';
import { useLazyQueryHook } from '../shared/hooks/useLazyQueryHook';
import { updateUpdateTokenService } from '../shared/hooks/handleUpdateToken';

const { Content } = Layout;
const siderCollapsedSize = 75;
const siderExpandedSize = 200;
const noSiderSize = 0;

const onError = (error: any, result: any) => {
  console.log(error, result, 'eqweqw');
}
const ExportDoc = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);
  const [showBar, setShowBar] = useState<boolean>(true);
  const [showHeaderBar, setShowHeaderBar] = useState<boolean>(true);
  const location = useLocation();
  const [goBack, setGoBack] = useState<number>(0);
  const [mainMargin, setmMinMargin] = useState<number>(0);
  const updateToken = (result: any) => {
    updateUpdateTokenService.updateTokenLocalStorage(result,tokenQuery,refreshToken);
  }
  const tokenQuery = useLazyQueryHook(RefreshToken, updateToken, onError);
  const refreshToken = localStorage.getItem('refreshToken');

  
  useEffect(() => {
    if(refreshToken) {
      updateUpdateTokenService.handleUpdateToken(tokenQuery,refreshToken);
    }
  }, [refreshToken]);
  const applySiderChanges = (showBarbool: boolean, ShowHeaderBarBool: boolean, goBackNo: number) => {
    setShowBar(showBarbool);
    setShowHeaderBar(ShowHeaderBarBool);
    setGoBack(goBackNo);
    setmMinMargin(showBarbool ? mainMargin === siderCollapsedSize ? siderCollapsedSize : siderExpandedSize : noSiderSize);
  }

  useEffect(() => {
    authService.isUserLoggedIn().subscribe((isUserLoggedIn: boolean) => {
      setIsUserLoggedIn(isUserLoggedIn);
      setmMinMargin(isUserLoggedIn ? siderExpandedSize : noSiderSize);
    });
  }, []);
  useEffect(() => {
    switch ('/' + location.pathname.split('/')[1]) {
      case routeConfig.proforma.path:
        applySiderChanges(false, true, 1);
        break;
      case routeConfig.preShipmentInvoice.path:
        applySiderChanges(false, true, 2);
        break;
      case routeConfig.commercialInvoice.path:
        applySiderChanges(false, true, 3);
        break;
      case routeConfig.packingListInvoice.path:
        applySiderChanges(false, true, 4);
        break;
      case routeConfig.purchaseOrderInvoice.path:
        applySiderChanges(false, true, 5);
        break;
      case routeConfig.finalPackingListInvoice.path:
        applySiderChanges(false, true, 6);
        break;
      case '/' + routeConfig.PdfViwer.path.split('/')[1]:
        setGoBack(7);
        break;
      case '/' + routeConfig.preShipmentInvoicePdf.path.split('/')[1]:
        setGoBack(8);
        break;
      case '/' + routeConfig.commercialInvoicePdf.path.split('/')[1]:
        setGoBack(9);
        break;
      case '/' + routeConfig.packingListInvoicePdf.path.split('/')[1]:
        setGoBack(10);
        break;
      case '/' + routeConfig.purchaseOrderPdf.path.split('/')[1]:
        setGoBack(11);
        break;
      case '/' + routeConfig.finalPackingListInvoicePdf.path.split('/')[1]:
        setGoBack(12);
        break;
      case routeConfig.login.path:
      case routeConfig.register.path:
      case routeConfig.forgotPassword.path:
      case '/user':
        applySiderChanges(false, true, 0);
        break;
      default:
        applySiderChanges(true, true, 0);
        break;
    }
  }, [location]);

  const sidebarChanged = (value: boolean) => {
    setmMinMargin(!value ? siderExpandedSize : siderCollapsedSize);
  }
  return (
    <Layout style={{ minHeight: '100%' }}>
      {isUserLoggedIn && showBar && <SideBarComponent sidebarChanged={sidebarChanged} />}
      <Layout className="site-layout" style={{ marginLeft: mainMargin }}>
        {isUserLoggedIn && showHeaderBar && <HeaderBar goBackData={goBack} goBackClicked={() => setmMinMargin(siderExpandedSize)} />}
        <Content className={"site-layout-background " + (isUserLoggedIn ? showHeaderBar ? 'global-container' : '' : '')}>
          <Switch>

            {/* {ROUTES.map((route, index) => (
                <RouteWithSubRoutes route={route} key={index} />
              ))} */}
            <PublicRoute path={routeConfig.register.path} key={routeConfig.register.key} exact name={routeConfig.register.name}
              component={<Register />} />
            <PublicRoute path={routeConfig.login.path} key={routeConfig.login.key} name={routeConfig.login.name}
              component={<LoginComponent />} />
            <PublicRoute path={routeConfig.confirmEmail.path} key={routeConfig.confirmEmail.key} name={routeConfig.confirmEmail.name}
              component={<ConfrimEmailComponent />} />

            <PublicRoute path={routeConfig.resetPassword.path} key={routeConfig.resetPassword.key} name={routeConfig.resetPassword.name}
              component={<ResetPasswordComponent />} />


            <PublicRoute path={routeConfig.forgotPassword.path} key={routeConfig.forgotPassword.key} name={routeConfig.forgotPassword.name}
              component={<ForgotPasswordComponent />} />

            <PrivateRoute path={routeConfig.home.path} key={routeConfig.home.key} exact name={routeConfig.home.name}
              component={<Dashboard />} />
            <PrivateRoute path={routeConfig.account.path} key={routeConfig.account.key} exact name={routeConfig.account.name}
              component={<AccountSettings />} />


            <PrivateRoute path={routeConfig.createCompany.path} key={routeConfig.createCompany.key} exact={routeConfig.createCompany.exact} name={routeConfig.createCompany.name}
              component={<CreateCompany />} />
            <PrivateRoute path={routeConfig.companyBank.path} key={routeConfig.companyBank.key} exact={routeConfig.companyBank.exact} name={routeConfig.companyBank.name}
              component={<AddCompanyBankDetails />} />
            <PrivateRoute path={routeConfig.companyAllBanksList.path} key={routeConfig.companyAllBanksList.key} exact={routeConfig.companyAllBanksList.exact} name={routeConfig.companyAllBanksList.name}
              component={<CompanyAllBanksList />} />
            {/* add and update company bank details */}
            <PrivateRoute path={routeConfig.addcompanyBank.path} key={routeConfig.addcompanyBank.key} exact={routeConfig.addcompanyBank.exact} name={routeConfig.addcompanyBank.name}
              component={<AddEditBank />} />
            <PrivateRoute path={routeConfig.updatecompanyBank.path} key={routeConfig.updatecompanyBank.key} exact={routeConfig.updatecompanyBank.exact} name={routeConfig.updatecompanyBank.name}
              component={<AddEditBank />} />

            <PrivateRoute path={routeConfig.consigneeList.path} key={routeConfig.consigneeList.key} exact name={routeConfig.consigneeList.name}
              component={<ConsigneeList />} />
            <PrivateRoute path={routeConfig.consignee.path} key={routeConfig.consignee.key} exact={routeConfig.consignee.exact} name={routeConfig.consignee.name}
              component={<Consignee />} />
            <PrivateRoute path={routeConfig.updateConsignee.path} key={routeConfig.updateConsignee.key} exact={routeConfig.updateConsignee.exact} name={routeConfig.updateConsignee.name}
              component={<Consignee />} />

            <PrivateRoute path={routeConfig.bank.path} key={routeConfig.bank.key} exact={routeConfig.bank.exact} name={routeConfig.bank.name}
              component={<AddEditBank />} />
            <PrivateRoute path={routeConfig.updateBank.path} key={routeConfig.updateBank.key} exact={routeConfig.updateBank.exact} name={routeConfig.updateBank.name}
              component={<AddEditBank />} />

            <PrivateRoute path={routeConfig.productList.path} key={routeConfig.productList.key} exact={routeConfig.productList.exact} name={routeConfig.productList.name}
              component={<ProductList />} />
            <PrivateRoute path={routeConfig.deliveryTerm.path} key={routeConfig.deliveryTerm.key} exact={routeConfig.deliveryTerm.exact} name={routeConfig.deliveryTerm.name}
              component={<DeliveryTerm />} />
            <PrivateRoute path={routeConfig.paymentTerm.path} key={routeConfig.paymentTerm.key} exact={routeConfig.paymentTerm.exact} name={routeConfig.paymentTerm.name}
              component={<PaymentTerm />} />
            <PrivateRoute path={routeConfig.packingType.path} key={routeConfig.packingType.key} exact={routeConfig.packingType.exact} name={routeConfig.packingType.name}
              component={<PackingType />} />
            <PrivateRoute path={routeConfig.shippingMode.path} key={routeConfig.shippingMode.key} exact={routeConfig.shippingMode.exact} name={routeConfig.shippingMode.name}
              component={<ShippingMode />} />

            <PrivateRoute path={routeConfig.portList.path} key={routeConfig.portList.key} exact={routeConfig.portList.exact} name={routeConfig.portList.name}
              component={<PortList />} />
            <PrivateRoute path={routeConfig.countryList.path} key={routeConfig.countryList.key} exact={routeConfig.countryList.exact} name={routeConfig.countryList.name}
              component={<CountryList />} />


            <PrivateRoute path={routeConfig.proformaList.path} key={routeConfig.proformaList.key} exact={routeConfig.proformaList.exact} name={routeConfig.proformaList.name}
              component={<ProformaList />} />
            <PrivateRoute path={routeConfig.proforma.path} key={routeConfig.proforma.key} exact={routeConfig.proforma.exact} name={routeConfig.proforma.name}
              component={<AddEditProforma />} />
            <PrivateRoute path={routeConfig.updateProforma.path} key={routeConfig.updateProforma.key} exact={routeConfig.updateProforma.exact} name={routeConfig.updateProforma.name}
              component={<AddEditProforma />} />

            <PrivateRoute path={routeConfig.PdfViwer.path} key={routeConfig.PdfViwer.key} exact={routeConfig.PdfViwer.exact} name={routeConfig.PdfViwer.name}
              component={<ProformaInvoicePdfViewer />} />


            <PrivateRoute path={routeConfig.preShipmentList.path} key={routeConfig.preShipmentList.key} exact={routeConfig.preShipmentList.exact} name={routeConfig.preShipmentList.name}
              component={<PreShipmentList />} />
            <PrivateRoute path={routeConfig.preShipmentInvoice.path} key={routeConfig.preShipmentInvoice.key} exact={routeConfig.preShipmentInvoice.exact} name={routeConfig.preShipmentInvoice.name}
              component={<AddEditPreShipmentInvoice />} />
            <PrivateRoute path={routeConfig.updatePreShipmentInvoice.path} key={routeConfig.updatePreShipmentInvoice.key} exact={routeConfig.updatePreShipmentInvoice.exact} name={routeConfig.updatePreShipmentInvoice.name}
              component={<AddEditPreShipmentInvoice />} />
            <PrivateRoute path={routeConfig.preShipmentInvoicePdf.path} key={routeConfig.preShipmentInvoicePdf.key} exact={routeConfig.preShipmentInvoicePdf.exact} name={routeConfig.preShipmentInvoicePdf.name}
              component={<PreShipmentInvoicePdf />} />

            <PrivateRoute path={routeConfig.commercialInvoice.path} key={routeConfig.commercialInvoice.key} exact={routeConfig.commercialInvoice.exact} name={routeConfig.commercialInvoice.name}
              component={<AddEditCommercialInvoice />} />
            <PrivateRoute path={routeConfig.commercialInvoicePdf.path} key={routeConfig.commercialInvoicePdf.key} exact={routeConfig.commercialInvoicePdf.exact} name={routeConfig.commercialInvoicePdf.name}
              component={<CommercialInvoicePdf />} />
            <PrivateRoute path={routeConfig.commercialInvoiceList.path} key={routeConfig.commercialInvoiceList.key} exact={routeConfig.commercialInvoiceList.exact} name={routeConfig.commercialInvoiceList.name}
              component={<CommercialInvoiceList />} />
            <PrivateRoute path={routeConfig.updateCommercialInvoice.path} key={routeConfig.updateCommercialInvoice.key} exact={routeConfig.updateCommercialInvoice.exact} name={routeConfig.updateCommercialInvoice.name}
              component={<CommercialInvoicePdf />} />

            <PrivateRoute path={routeConfig.packingListInvoice.path} key={routeConfig.packingListInvoice.key} exact={routeConfig.packingListInvoice.exact} name={routeConfig.packingListInvoice.name}
              component={<AddEditPackingListInvoice />} />
            <PrivateRoute path={routeConfig.allPackingList.path} key={routeConfig.allPackingList.key} exact={routeConfig.allPackingList.exact} name={routeConfig.allPackingList.name}
              component={<PackingList />} />
            <PrivateRoute path={routeConfig.updatePackingListInvoice.path} key={routeConfig.updatePackingListInvoice.key} exact={routeConfig.updatePackingListInvoice.exact} name={routeConfig.updatePackingListInvoice.name}
              component={<AddEditPackingListInvoice />} />
            <PrivateRoute path={routeConfig.packingListInvoicePdf.path} key={routeConfig.packingListInvoicePdf.key} exact={routeConfig.packingListInvoicePdf.exact} name={routeConfig.packingListInvoicePdf.name}
              component={<PackingListPdf />} />

            <PrivateRoute path={routeConfig.purchaseOrderInvoice.path} key={routeConfig.purchaseOrderInvoice.key} exact={routeConfig.purchaseOrderInvoice.exact} name={routeConfig.purchaseOrderInvoice.name}
              component={<AddEditPurchaseOrder />} />
            <PrivateRoute path={routeConfig.updatePurchaseOrderInvoice.path} key={routeConfig.updatePurchaseOrderInvoice.key} exact={routeConfig.updatePurchaseOrderInvoice.exact} name={routeConfig.updatePurchaseOrderInvoice.name}
              component={<AddEditPurchaseOrder />} />
            <PrivateRoute path={routeConfig.purchaseOrderList.path} key={routeConfig.purchaseOrderList.key} exact={routeConfig.purchaseOrderList.exact} name={routeConfig.purchaseOrderList.name}
              component={<PurchaseOrderList />} />
            <PrivateRoute path={routeConfig.purchaseOrderPdf.path} key={routeConfig.purchaseOrderPdf.key} exact={routeConfig.purchaseOrderPdf.exact} name={routeConfig.purchaseOrderPdf.name}
              component={<PurchaseOrderPdf />} />

            <PrivateRoute path={routeConfig.finalPackingListInvoice.path} key={routeConfig.finalPackingListInvoice.key} exact={routeConfig.finalPackingListInvoice.exact} name={routeConfig.finalPackingListInvoice.name}
              component={<AddEditFinalPackingListInvoice />} />
            <PrivateRoute path={routeConfig.allFinalPackingList.path} key={routeConfig.allFinalPackingList.key} exact={routeConfig.allFinalPackingList.exact} name={routeConfig.allFinalPackingList.name}
              component={<FinalPackingList />} />
            <PrivateRoute path={routeConfig.updateFinalPackingListInvoice.path} key={routeConfig.updateFinalPackingListInvoice.key} exact={routeConfig.updateFinalPackingListInvoice.exact} name={routeConfig.updateFinalPackingListInvoice.name}
              component={<AddEditFinalPackingListInvoice />} />
            <PrivateRoute path={routeConfig.finalPackingListInvoicePdf.path} key={routeConfig.finalPackingListInvoicePdf.key} exact={routeConfig.finalPackingListInvoicePdf.exact} name={routeConfig.finalPackingListInvoicePdf.name}
              component={<FinalPackingListPdf />} />
            <PrivateRoute path={'/'} key={routeConfig.home.key} exact name={routeConfig.home.name}
              component={<Dashboard />} />
            <PrivateRoute component={<PageNotFound />} name={'Page Not Found'} />
          </Switch >
        </Content>
        {/* {isUserLoggedIn && <FooterBar />} */}
      </Layout>
    </Layout>

  );
}

export default ExportDoc;

function RouteWithSubRoutes({ route }: any) {
  const { component, urlData } = route;
  return (
    route.public ? <PublicRoute component={component} rest={urlData} /> : <PrivateRoute component={component} rest={urlData} />
  );
}